import {KpSvelteComponentWrapperComponent} from 'src/core';
import type {StateProvider} from '@uirouter/angularjs';

/*@ngInject*/
export default function facetTypesRoutes($stateProvider: StateProvider) {
    let facetTypesModule: { default: any; };
    $stateProvider
        .state({
            name: 'facet-types',
            url: '/facet-types',
            component:  KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => facetTypesModule.default,
            },
            lazyLoad: async () => {
                facetTypesModule = await import(/* webpackChunkName: "facet-types" */ './KpFacetTypes.svelte');
                return null;
            }
        });
}